import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var u;
import t from "react";
import { useIsoMorphicEffect as d } from "./use-iso-morphic-effect.js";
import { useServerHandoffComplete as f } from "./use-server-handoff-complete.js";
var l = 0;

function r() {
  return ++l;
}

var I = (u = t.useId) != null ? u : function () {
  var n = f(),
      _t$useState = t.useState(n ? r : null),
      _t$useState2 = _slicedToArray(_t$useState, 2),
      e = _t$useState2[0],
      o = _t$useState2[1];

  return d(function () {
    e === null && o(r());
  }, [e]), e != null ? "" + e : void 0;
};
export { I as useId };